/**
 * Insert merge-field tokens at the caret in inputs, textareas, or contentEditable editors.
 */

export function insertIntoInput(element, token) {
  if (!element) return { value: token, caret: token.length };

  const start = element.selectionStart ?? element.value?.length ?? 0;
  const end = element.selectionEnd ?? start;
  const current = element.value ?? '';
  const before = current.substring(0, start);
  const after = current.substring(end);
  const value = before + token + after;
  const caret = start + token.length;

  return { value, caret };
}

export function applyInputInsert(element, token, onChange) {
  const { value, caret } = insertIntoInput(element, token);
  onChange?.(value);
  requestAnimationFrame(() => {
    if (!element) return;
    element.focus();
    element.setSelectionRange?.(caret, caret);
  });
  return value;
}

export function insertIntoContentEditable(element, token) {
  if (!element || typeof document === 'undefined') return;

  element.focus();
  const selection = window.getSelection();

  if (selection && selection.rangeCount > 0) {
    const range = selection.getRangeAt(0);
    range.deleteContents();
    const node = document.createTextNode(token);
    range.insertNode(node);
    range.setStartAfter(node);
    range.setEndAfter(node);
    selection.removeAllRanges();
    selection.addRange(range);
    return;
  }

  document.execCommand('insertText', false, token);
}
